import { useMemo } from 'react';
import {
    RemoveRedEye,
    ImportExport,
    Payments,
    SvgIconComponent,
    Delete,
    Schedule,
    Edit,
    Archive,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { InvoiceStatus, InvoiceTableRowStatus } from '@lendica/utils';
import { BillOrDealRow, BillTableRow, ActionType } from '../sharedTypes';

export interface Action {
    title: string;
    onClick(): void;
    Icon: SvgIconComponent;
}

export const useActions = (row: BillOrDealRow | undefined): Action[] => {
    const navigate = useNavigate();

    return useMemo(() => {
        const status = row?.status;

        const viewInvoice = {
            title: 'View invoice',
            onClick() {
                navigate(`${row?.type}/${row?.id}/view`);
            },
            Icon: RemoveRedEye,
        };

        const activate = {
            title: 'Schedule PayLater',
            onClick() {
                navigate(`${row?.type}/${row?.id}/confirm`);
            },
            Icon: Schedule,
        };

        const archive = {
            title: 'Delete',
            onClick() {
                // navigate(`${row?.type}/${row?.id}/delete`);
                // payLaterAPI.archiveBill(`${row?.id}`);
            },
            Icon: Delete,
        };

        const seePaymentSchedules = {
            title: 'See payment schedules',
            onClick() {},
            Icon: Payments,
        };

        const exportReport = {
            title: 'Export report',
            onClick() {},
            Icon: ImportExport,
        };

        const res: Action[] = [viewInvoice];

        if (status === InvoiceStatus.Created) {
            res.push(activate);
            // res.push(archive);
        }

        // if (status === DealStatus.Available) {
        //     res.push(activate);
        // } else if (status === DealStatus.InProgress) {
        //     res.push(seePayemntSchedules);
        //     res.push(exportReport);
        // } else if (status === DealStatus.Overdue) {
        //     res.push(seePayemntSchedules);
        //     res.push(exportReport);
        // } else if (status === DealStatus.Complete) {
        //     res.push(exportReport);
        // }

        return res;
    }, [row]);
};

export interface ActionNew {
    type: ActionType;
    label: string;
    onClick(): void;
    icon: SvgIconComponent;
}

export interface ActionCallbacks {
    onArchive?: (billId: string) => void;
}

export const useActionsNew = (
    row: BillTableRow | undefined,
    callbacks?: ActionCallbacks
): ActionNew[] => {
    const navigate = useNavigate();

    return useMemo(() => {
        const res: ActionNew[] = [];

        const schedule = {
            type: ActionType.Schedule,
            label: 'Schedule PayLater',
            onClick() {
                navigate(`${row?.type}/${row?.id}/confirm`);
            },
            icon: Schedule,
        };

        const edit = {
            type: ActionType.Edit,
            label: 'Edit',
            onClick() {
                navigate(`${row?.type}/${row?.id}/confirm`);
            },
            icon: Edit,
        };

        const viewInvoice = {
            type: ActionType.View,
            label: 'View invoice',
            onClick() {
                navigate(`${row?.type}/${row?.id}/view`);
            },
            icon: RemoveRedEye,
        };

        const archive = {
            type: ActionType.Archive,
            label: 'Delete',
            onClick() {
                if (callbacks?.onArchive && row?.id) {
                    callbacks.onArchive(row.id);
                }
            },
            icon: Delete,
        };

        switch (row?.status) {
            case InvoiceTableRowStatus.Ready:
                res.push(schedule);
                res.push(edit);
                res.push(viewInvoice);
                res.push(archive);
                break;
            default:
                res.push(viewInvoice);
                break;
        }

        return res;
    }, [row]);
};
